/**
 * Controller: TemplatesCreatePricingMembers
 */
angular.module('acme.application.templates.create.pricing.members.controllers', [
    'ui.bootstrap',
    'acme.common.service.api',
    'acme.common.service.helpers',
    'acme.common.service.templates',
    'acme.common.service.discounts',
    'acme.common.service.templates',
    'acme.common.factory.wizard',
    'acme.view.application.forms.modals.confirm.controllers',
    'acme.view.application.templates.showMembershipsModal.controllers'
  ])
  .controller('TemplatesCreatePricingMembersController', ['$scope', '$timeout', '$uibModal', 'ApiService',
    'TemplatesService', 'DiscountsService', 'ValidateService', 'HelpersService', 'WizardFactory', '$q',
    function ($scope, $timeout, $uibModal, ApiService, TemplatesService, DiscountsService, ValidateService,
      HelpersService, WizardFactory, $q) {

      var CONSTANTS = {
        LIMIT_MODAL: {
          OK: 'Continue with discount',
          CANCEL: 'Cancel',
          TITLE: 'Are you sure?',
          MESSAGE: 'Your limit will be removed when you apply a discount'
        },
        NO_DISCOUNT: 'NO_DISCOUNT',
        ERROR: {
          SINGLE_DISCOUNT: 'You can have only one discount per membership level',
          NO_MEMBERSHIP: 'Please select at least one membership level',
          NO_TICKET_TYPE: 'Please select at least one ticket type',
          CONFLICTING: 'Each membership level can only have one discount and limit per ticket type per timeframe',
          TICKET_TYPE: 'Each membership level can only have one limit per ticket type per timeframe',
          DISCOUNT: 'Each membership level can only have one discount',
          TIME_FRAME: 'Limit per day cannot be larger than per event',
          PRICE_POINT: 'price-point',
          PLEASE_WAIT: 'Please wait...'
        },
        RESTRICT: {
          TOOLTIP: 'Specify the list of valid memberships by creating Rules.\n\nDiscounts and limits are optional.',
          NONE: 'Only some membership levels can purchase admission (Rules below define list of levels)',
          ALL: 'None. All members can purchase admission.'
        },
        MESSAGES: {
          FIX_ERRORS: 'Rule changes may not be saved due to errors. Would you like to fix these before continuing?',
          FIX_ERRORS_HEADING: 'Some member rules have errors',
          FIX_ERRORS_YES: 'Fix Errors',
          FIX_ERRORS_NO: 'Don\'t Fix and Continue'
        }
      };

      $scope.templatesCreatePricingMembers = {

        viewIds: ['application.templates.create.pricing', 'application.templates.edit.pricing'],
        CONSTANTS: CONSTANTS,
        template: {},
        showModal: {},

        wizard: {},

        model: {},

        discountCodes: [],

        memberRules: [],
        memberCategories: [],

        areMemberDiscountsDirty: false,

        memberRulesMap: [],
        memberRulesLoaded: false,
        membershipLevelsLoaded: false,
        priceListsLoaded: false,

        loadingDiscounts: false,

        limit: {
          timeframe: 'day'
        },

        timeFrames: [{
          label: 'Per Day',
          name: 'day',
          order: 50
        }, {
          label: 'Per Event',
          name: 'lifetime',
          order: 100
        }],

        limitTypes: [{
          label: 'Each',
          name: 'forEachItem'
        }, {
          label: 'Across',
          name: 'acrossAllItems'
        }],
        discountFilters: [{
          label: 'All Rules',
          name: ''
        }, {
          label: 'Rules without discounts and limits',
          name: 'norules'
        }, {
          label: 'Rules with discounts and limits',
          name: 'both'
        }, {
          label: 'Rules with only discounts (no limits)',
          name: 'discounts'
        }, {
          label: 'Rules with only limits (no discounts)',
          name: 'limits'
        }],

        filterDiscount: '',

        memberRulePricePoints: [],
        multiSelectMembershipLabels: {
          selectAll: "Select all",
          selectNone: "Select none",
          search: "Search by Membership Level name...",
          nothingSelected: "Select Levels ..."
        },
        multiSelectTicketLabels: {
          selectAll: "Select all",
          selectNone: "Select none",
          search: "Search by ticket type name...",
          nothingSelected: "Select a ticket type"
        },

        getMemberRulesMap: function(rules, allTimeFrames) {
          var _rules = rules || [],
            conflictHash = _rules.reduce(function(hash, rule) {
              rule.membershipCategories.forEach(function(membership) {
                var membershipHash = hash[membership.id] || {
                    discountsHash: {},
                    pricePointHash: {},
                    timeFrameHash: {},
                    rules: []
                  },
                  discountCode =
                    (rule.discountCode && rule.discountCode.id) || CONSTANTS.NO_DISCOUNT,
                  hasPricePoints = rule.pricepoints.length > 0,
                  pricepoints = hasPricePoints ? rule.pricepoints : [];

                membershipHash.discountsHash[discountCode] = true;
                membershipHash = pricepoints.reduce(function(
                  hash,
                  pricepoint
                ) {
                  var pricepointId = pricepoint.id,
                    timeFrameName = rule.timeFrame.name,
                    compoundKey = [pricepointId, timeFrameName].join(':'),
                    pricePointHash = hash.pricePointHash || {},
                    timeFrameHash = hash.timeFrameHash || {},
                    timeFramesObjs = timeFrameHash[pricepointId] || {},
                    count = pricePointHash[compoundKey] || 0;

                  timeFramesObjs[timeFrameName] = rule.quantity;
                  timeFrameHash[pricepointId] = timeFramesObjs;

                  if(hasPricePoints) {
                    pricePointHash[compoundKey] = count + 1;
                  } else {
                    allTimeFrames.forEach(function(time) {
                      compoundKey = [pricepointId, time.name].join(':');
                      count = pricePointHash[compoundKey] || 0;
                      pricePointHash[compoundKey] = count + 1;
                    });
                  }

                  hash.pricePointHash = pricePointHash;
                  hash.timeFrameHash = timeFrameHash;
                  return hash;
                }, membershipHash);

                membershipHash.rules.push(rule);
                hash[membership.id] = membershipHash;
              });

              return hash;
            }, {});

            return Object.keys(conflictHash).map(function(key) {
              return conflictHash[key];
            });
        },

        getConflictingDiscountRules: function(memberRulesMap) {
          var self = $scope.templatesCreatePricingMembers,
            moreThanOneDiscount = function(memberRuleHash) {
              return Object.keys(memberRuleHash).length > 1;
            };

          return self._filterRulesOver(memberRulesMap, 'discountsHash', moreThanOneDiscount);
        },

        getConflictingPricepointRules: function(memberRulesMap) {
          var self = $scope.templatesCreatePricingMembers,
            moreThanOnePricepoint = function(pricePointHash) {
              return Object.keys(pricePointHash).filter(function(key) {
                return pricePointHash[key] > 1;
              }).length > 0;
            };

          return self._filterRulesOver(memberRulesMap, 'pricePointHash', moreThanOnePricepoint);
        },

        getConflictingTimeframeRules: function(memberRulesMap) {
          var self = $scope.templatesCreatePricingMembers,
            timeFrames = self.timeFrames.sort(function(a, b) {
              return a.order > b.order ? 1 : -1;
            }),
            timeFramesLessThan = function(memberRuleHash) {
              return Object.keys(memberRuleHash)
                .map(function(key) {
                  var hash = memberRuleHash[key] || {};
                  return Object.keys(hash).map(function(hashKey) {
                    return {
                      name: hashKey,
                      value: hash[hashKey]
                    };
                  });
                })
                .map(function(pricepointTimeFrame) {
                  return pricepointTimeFrame.length >= self.timeFrames.length ? pricepointTimeFrame
                    .sort(function(a, b) {
                      return a.value > b.value ? 1 : -1;
                    })
                    .map(function(timeFrame, index) {
                      return timeFrames[index].name === timeFrame.name;
                    })
                    .filter(function(value) {
                      return value;
                    }).length !== timeFrames.length : false;
                })
                .filter(function(value) {
                  return value;
                }).length !== 0;
            };

          return self._filterRulesOver(memberRulesMap, 'timeFrameHash', timeFramesLessThan);
        },

        _filterRulesOver: function(memberRulesMap, property, check) {
          var _memberRulesMap =  memberRulesMap || [],
            _property = property || '';

          return _memberRulesMap.filter(function(rule) {
            var hash = rule[_property] || {};

            return check(hash);
          });
        },

        _setMemberRulesError: function(testFunction, memberRulesMap) {
            var list = testFunction.call($scope.templatesCreatePricingMembers, memberRulesMap),
                invalid = list.length > 0;

            list.forEach(function(duplicateMap) {
              duplicateMap.rules.forEach(function(rule) {
               rule._errors.push(true);
              });
            });

            return invalid;
        },

        init: function () {

          this.initWizard(true);

          ValidateService.addFieldTests(this.wizard.getStep('members').validators);

          $scope.$on('TemplatesService::Update', this.onTemplatesServiceUpdate);
          $scope.$on('DiscountsService::Update', this.onDiscountsServiceUpdate);

          $scope.$on('TemplatesCreateController::Save', this.onTemplatesCreateControllerSave);
          $scope.$on('TemplatesCreatePricing::Update', this.onTemplatesCreatePricingUpdate);

          this.dataLoaded = this.loadData();
        },

        initWizard: function (validate) {
          var self = $scope.templatesCreatePricingMembers;

          this.wizard = new WizardFactory();
          this.wizard.init({
            name: 'members',
            validators: [{
            //   field: 'templates-create-pricing-members-rule',
            //   equal: {
            //     message: CONSTANTS.ERROR.SINGLE_DISCOUNT,
            //     test: function () {
            //       return [TemplatesService.hasValidDiscounts(self.memberRules, "membershipCategories"),
            //         true
            //       ];
            //     }
            //   }
            // }, {
              field: 'templates-create-pricing-members-rule-conflicting-validator',
              equal: {
                message: 'NO_MESSAGE',
                test: function () {
                  return [!self.memberRules._hasError, true];
                }
              }
            }, {
              field: 'templates-create-pricing-members-rule-conflicting',
              equal: {
                message: 'NO_MESSAGE',
                test: function () {
                  return [true, true];
                }
              }
            }, {
              field: 'templates-create-pricing-members-rule-selected',
              equal: {
                message: CONSTANTS.ERROR.NO_MEMBERSHIP,
                test: function () {
                  return [TemplatesService.hasMembershipDiscount(self.memberRules,
                    "membershipCategories"), true];
                }
              }
            }, {
              field: 'templates-create-pricing-members-rule-pricepoint-incomplete',
              equal: {
                message: CONSTANTS.ERROR.NO_TICKET_TYPE,
                test: function () {
                  var hasIncompleteRules = self.memberRules.filter(function(rule) {
                    var hasPricePoint = !rule._showLimitButton,
                      hasTicketType = rule.pricepoints.length > 0,
                      error = false;

                    if(hasPricePoint && !hasTicketType) {
                      error = true;
                      rule._errors = [CONSTANTS.ERROR.PRICE_POINT].concat(rule._errors);
                    }

                    return error;
                  }).length > 0;

                  return [!hasIncompleteRules, true];
                }
              }
            }]
          });

          if (validate) {
            this.validate();
          }

        },

        validate: function () {
          $timeout(function () {
            var self = $scope.templatesCreatePricingMembers;

            self.memberRules.forEach(function(rule) {
              rule._errors = [];
            });
            self.memberRulesMap = self.getMemberRulesMap(self.memberRules, self.timeFrames);
            self.memberRules._hasError = self.runMemberRulesValidation(self.memberRulesMap);
            self.wizard.validate();
            $scope.$emit('TemplatesCreatePricingController::TabCheck', {
              tab: 'members',
              invalid: self.wizard.hasErrors('members')
            });
          }, 0);
        },

        hasErrors: function() {
          return this.wizard.hasErrors('members');
        },

        runMemberRulesValidation: function(memberRulesMap) {
          var discounts = this._setMemberRulesError(
              this.getConflictingDiscountRules,
              memberRulesMap
            ),
            priceList = this._setMemberRulesError(
              this.getConflictingPricepointRules,
              memberRulesMap
            ),
            timeFrame = this._setMemberRulesError(
              this.getConflictingTimeframeRules,
              memberRulesMap
            ),
          errorMessage = null,
          step = 'members',
          validator = 'templates-create-pricing-members-rule-conflicting';

          if(discounts && priceList) {
            errorMessage = CONSTANTS.ERROR.CONFLICTING;
          } else if (discounts) {
            errorMessage = CONSTANTS.ERROR.DISCOUNT;
          } else if (priceList) {
            errorMessage = CONSTANTS.ERROR.TICKET_TYPE;
          } else if (timeFrame) {
            errorMessage = CONSTANTS.ERROR.TIME_FRAME;
          } else {
            errorMessage = '';
          }

          this.wizard.removeValidator(step, validator);
          this.wizard.addValidator(step, {
            field: validator,
            equal: {
              message: errorMessage,
              test: function() {
                return [!errorMessage, true];
              }
            }
          });

          return !!errorMessage;
        },

        showPricePointBorderError: function(rule) {
          return rule._errors && rule._errors.filter(function(error) {
            return error === CONSTANTS.ERROR.PRICE_POINT;
          }).length > 0;
        },

        loadData: function() {
          return $q.all([
            this.getMembershipLevels(),
            this.getPriceLists()
          ])
            .then(this.onTemplatesCreatePricingUpdate)
            .then(this.onDiscountsServiceUpdate)
            .then(this.onTemplatesServiceUpdate)
            .catch(this.onTemplatesCreatePricingUpdate);
        },

        getPriceLists: function() {
          this.priceListsLoaded = false;
          return ApiService.price.types.list(HelpersService.getPaginator())
            .then(this.setPriceList.bind(this))
            .then(this.updateRulesPriceList.bind(this))
            .catch(this.setPriceList.bind(this));
        },

        setPriceList: function(response) {
          var priceList = response &&
            response.data &&
            response.data.payload &&
            response.data.payload.list || [];

          this.memberRulePricePoints = priceList.sort(this._orderByBusinessRules);

          return this.memberRulePricePoints;
        },

        updateRulesPriceList: function (priceList) {
          this.memberRules.forEach(function(rule) {
            var newPricePoints = priceList.map(function(newPricePoint) {
              var ticked =
                rule.pricepoints.filter(function(oldPricePoint) {
                  return newPricePoint.id === oldPricePoint.id;
                }).length > 0;

              return Object.assign({}, newPricePoint, { ticked: ticked });
            });

            rule.allPricepoints = newPricePoints;
            rule.pricepoints = newPricePoints.filter(function(pricepoint) {
              return pricepoint.ticked;
            });
          });
          this.priceListsLoaded = true;
        },

        getMembershipLevels: function () {
          var props = HelpersService.getPaginator();
          props.isPublished = 1;
          props.summarize = 1;
          props.salesChannels = 'online,pointOfSale,insideSalesIndividual,kiosk,customerRep';
          this.membershipLevelsLoaded = false;

          return ApiService.membership.categories.list(props)
            .then(this.success.getMembershipLevels)
            .catch(this.error.getMembershipLevels);
        },

        getMembershipDiscounts: function () {
          var self = this;

          this.memberRulesLoaded = false;

          if (!this.loadingDiscounts && this.areMemberDiscountsDirty !== true && this.template.id) {
            this.loadingDiscounts = true;
            this.dataLoaded
              .then(function() {
               return ApiService.program.entitlements.list(self.template.id);
              })
              .then(this.success.getMembershipDiscounts)
              .catch(this.error.getMembershipDiscounts);
          } else {
            this.memberRulesLoaded = true;
            this.loadingDiscounts = false;
            this.validate();
          }
        },

        findDiscountCode: function (id) {
          return DiscountsService.find(id);
        },

        checkMemberRules: function () {
          if (this.memberRules instanceof Array && this.memberRules.length > 0) {
            this.hasMemberRules = true;
          } else {
            this.hasMemberRules = false;
          }
        },

        hasRules: function() {
          return this.hasMemberRules && this.memberRulesLoaded && this.membershipLevelsLoaded && this.priceListsLoaded;
        },

        addMemberRule: function () {
          this.memberRules.push({
            membershipCategories: [],
            allMembershipLevels: this.selectMembershipLevels(),
            discountCode: null,
            limitType: this.limitTypes[0],
            timeFrame: this.timeFrames[0],
            quantity: '',
            _showLimitButton: true,
            _errors: [],
            pricepoints: [],
            allPricepoints: this.selectPricepoints()
          });
          this.checkMemberRules();
          this.areMemberDiscountsDirty = true;
          this.onTemplatesCreateControllerSave(null, null, true);
        },

        validateQuantity: function(rule) {
          rule.quantity = parseInt(rule.quantity, 10) || 0;
        },

        removeAppliedDiscount: function (rule) {
          var self = this;

          rule._showLimitButton = true;
          this.resetLimits(rule);
        },

        addLimit: function(rule) {
          rule._showLimitButton = false;
          rule.quantity = 0;
        },

        hasLimits: function(rule) {
          var quantity = parseInt(rule.quantity, 10) || 0;

          return rule.pricepoints.length > 0 || quantity > 0;
        },

        resetLimits: function(rule) {
          rule.quantity = "";
          rule.limitType = this.limitTypes[0];
          rule.pricepoints = [];
        },

        removeMemberRule: function (index) {
          console.log('templatesCreatePricingMembers::removeAccountDiscount', index);

          this.memberRules.splice(index, 1);
          this.checkMemberRules();
          this.areMemberDiscountsDirty = true;
          $timeout(function () {
            var self = $scope.templatesCreatePricingMembers;

            self.onTemplatesCreateControllerSave(null, null, true);
          }, 0);
        },

        findMembershipLevel: function (id) {
          var i, ii,
            r = false;

          for (i = 0, ii = this.membershipLevels.length; i < ii; i++) {
            if (id === this.membershipLevels[i].id) {
              r = {
                index: i,
                membershipLevel: this.membershipLevels[i]
              };
              break;
            }
          }

          return r;
        },

        findPricePoint: function (id) {
          var i, ii,
            r = false;

          for (i = 0, ii = this.memberRulePricePoints.length; i < ii; i++) {
            if (id === this.memberRulePricePoints[i].id) {
              r = {
                index: i,
                pricepoint: this.memberRulePricePoints[i]
              };
              break;
            }
          }

          return r;
        },

        findSavedMemberDiscount: function (id) {

          var i, ii,
            r = false;

          for (i = 0, ii = this.savedMemberDiscounts.discounts.length; i < ii; i++) {
            if (this.savedMemberDiscounts.discounts[i].category.id === id) {
              r = {
                discount: this.savedMemberDiscounts.discounts[i],
                index: i
              };
              break;
            }
          }

          return r;

        },

        areAllCategoriesRestricted: function () {
          var i, ii,
            j, jj,
            exists;

          for (i = 0, ii = this.membershipLevels.length; i < ii; i++) {
            exists = false;
            for (j = 0, jj = this.savedMemberDiscounts.restrictions.length; j < jj; j++) {
              if (this.membershipLevels[i].id === this.savedMemberDiscounts.restrictions[j].id) {
                exists = true;
                break;
              }
            }
            if (!exists) {
              break;
            }
          }

          return exists;
        },

        showMemberships: function (rule) {
          var self = $scope.templatesCreatePricingMembers;

          if (rule && (rule.membershipCategories instanceof Array) && (rule.membershipCategories.length)) {
            self.showModal = $uibModal.open({
              templateUrl: 'views/application/views/templates/modals/showMembershipsModal.tpl.html',
              size: 'md',
              controller: 'TemplatesShowMembershipsModalController',
              resolve: {
                MembershipsListData: function () {
                  return rule.membershipCategories;
                }
              }
            });
          }
        },

        showDiscount: function (discountId) {
          var self = $scope.templatesCreatePricingMembers;

          self.showModal = $uibModal.open({
            templateUrl: 'views/application/views/templates/modals/discount/discount.tpl.html',
            size: 'lg',
            controller: 'TemplatesModalsDiscountController',
            resolve: {
              discountId: function () {
                return discountId;
              }
            }
          });
        },

        applyRestrictions: function () {
          var memberRules = null,
            entitlementConfig = null,
            self = this;

          if (!self.model.eventTemplateId) {
            self.model.eventTemplateId = self.template.id;
          }

          memberRules = self.memberRules.map(function(rule) {
            return {
              membershipLevelInfo: rule.membershipCategories.map(function(membership) {
                var membershipInfo = self.findMembershipLevel(membership.id);
                return membershipInfo ? {
                  id: membershipInfo.membershipLevel.id,
                  name: membershipInfo.membershipLevel.name
                } : null;
              }).filter(function(membership) {
                return membership;
              }),
              pricepointInfo: rule.pricepoints.map(function(pricepoint) {
                var pricepointInfo = self.findPricePoint(pricepoint.id);
                return pricepointInfo ? {
                  id: pricepointInfo.pricepoint.id,
                  name: pricepointInfo.pricepoint.name
                } : null;
              }).filter(function(princepoint) {
                return princepoint;
              }),
              discountCodeInfo: [rule.discountCode].map(function(discount) {
                return discount ? {
                  id: discount.id,
                  name: discount.name
                } : null;
              }).filter(function(discount) {
                return discount;
              }),
              quantity: rule.quantity,
              limitType: rule.limitType,
              timeFrame: {
                value: 0,
                period: rule.timeFrame.name
              }
            };
          });

          entitlementConfig = memberRules.map(function(memberRule) {
            var result = {
              quantity: memberRule.quantity,
              timeFrame: memberRule.timeFrame
            };

            if(memberRule.membershipLevelInfo.length > 0) {
              result.membershipLevels = {
                membershipLevelInfo: memberRule.membershipLevelInfo,
                ruleApplies: memberRule.limitType.name
              };
            }

            if(memberRule.pricepointInfo.length > 0 ) {
              result.pricepoints = {
                pricepointInfo: memberRule.pricepointInfo,
                ruleApplies: memberRule.limitType.name
              };
            }

            if(memberRule.discountCodeInfo.length > 0 ) {
              result.discountCodes = {
                discountCodeInfo: memberRule.discountCodeInfo,
                ruleApplies: memberRule.limitType.name
              };
            }

            return result;
          });

          self.model.entitlementConfig = entitlementConfig;
        },

        processMemberships: function (data) {
          var i, ii,
            saved = [],
            hasPricePoints = false,
            hasMembershipLevels = false,
            self = this;

          if (data) {
            self.model.id = data.id;
            self.model.eventTemplateId = self.template.id;
            self.model.salesRuleSetId = data.salesRuleSetId;
            self.model.name = data.name;
            self.model.salesRuleConfig = data.salesRuleConfig || [];
            self.model.ticketRuleConfig = data.ticketRuleConfig || [];
            self.savedMemberDiscounts = data.entitlementConfig || [];
            self.memberRules = [];

            if (self.savedMemberDiscounts instanceof Array) {
              self.savedMemberDiscounts.forEach(function(savedMemberDiscount) {
                  var discountCodes = savedMemberDiscount.discountCodes,
                  discount = discountCodes && discountCodes.discountCodeInfo[0] || {},
                  discountFound = self.findDiscountCode(discount && discount.id),
                  discountCode = discountFound && discountFound.code || null,
                  pricepoints = savedMemberDiscount.pricepoints,
                  ruleTimeFrame = savedMemberDiscount.timeFrame || {},
                  membershipLevels =  savedMemberDiscount.membershipLevels;

                  hasPricePoints = (pricepoints && pricepoints.pricepointInfo instanceof Array) &&
                    pricepoints.pricepointInfo.length;
                  hasMembershipLevels = (membershipLevels.membershipLevelInfo instanceof Array) &&
                    membershipLevels.membershipLevelInfo.length;

                  self.memberRules.push({
                    membershipCategories: hasMembershipLevels ? membershipLevels.membershipLevelInfo: [],
                    allMembershipLevels: self.selectMembershipLevels(hasMembershipLevels ? membershipLevels.membershipLevelInfo : []),
                    discountCode: discountCode,
                    timeFrame: self.timeFrames.filter(function(timeFrame) {
                      return timeFrame.name === ruleTimeFrame.period;
                    })[0] || self.timeFrames[0],
                    limitType: self.limitTypes.filter(function(limitType) {
                      return limitType.name === membershipLevels.ruleApplies;
                    })[0] || self.limitTypes[0],
                    quantity: hasPricePoints ? savedMemberDiscount.quantity : '',
                    pricepoints: hasPricePoints ? pricepoints.pricepointInfo : [],
                    allPricepoints: self.selectPricepoints(hasPricePoints ? pricepoints.pricepointInfo : []),
                    _errors: [],
                    _showLimitButton: !hasPricePoints
                  });
              });
            }

            this.checkMemberRules();
            console.log('TemplatesCreatePricingMembersController::processMemberships', this.memberRules, saved,
              this.savedMemberDiscounts);
          }
        },

        _buildHash: function(list) {
          var _list = list || [];

          return _list.reduce(function(hash, item) {
            hash[item.id] = item;

            return hash;
          }, {});
        },

        _selectItems: function(allItems, givenItems) {
          var hash = this._buildHash(givenItems),
            _allItems = allItems || [];

          return _allItems.map(function(item) {
            return Object.assign({}, item, {
              ticked: !!hash[item.id]
            });
          });
        },

        selectPricepoints: function (list) {
          return this._selectItems(this.memberRulePricePoints, list);
        },

        selectMembershipLevels: function (list) {
          return this._selectItems(this.membershipLevels, list);
        },

        success: {

          getMembershipDiscounts: function (response) {
            var self = $scope.templatesCreatePricingMembers;

            self.processMemberships(response.data.payload);
            self.memberRulesLoaded = true;
            self.loadingDiscounts = false;
            self.validate();
          },

          getMembershipLevels: function (response) {
            var self = $scope.templatesCreatePricingMembers;
            self.membershipLevels = self.processMembershipLevels(response.data.payload.list);
            self.membershipLevelsLoaded = true;
          }

        },

        error: {
          getMembershipDiscounts: function (response) {
            var self = $scope.templatesCreatePricingMembers;

            if (response.status !== 404) {
              self.error.generic(response);
            }
            self.memberRulesLoaded = true;
            self.loadingDiscounts = false;
            self.validate();
          },
          getMembershipLevels: function (response) {
            var self = $scope.templatesCreatePricingMembers;

            self.error.generic(response);
            self.membershipLevelsLoaded = true;
          },
          generic: function (response) {
            $scope.$emit('TemplatesCreateController::Error', {
              message: response.data && response.data.error
            });
          }
        },

        onTemplatesCreateControllerSave: function (e, data, skipValidation) {
          var self = $scope.templatesCreatePricingMembers;

          if (self.memberRulesLoaded && self.membershipLevelsLoaded && self.priceListsLoaded) {
            self.applyRestrictions();

            TemplatesService.setEntitlement(self.model);

            if(!skipValidation && self.memberRules.length > 0) {
              self.validate();
            }
          }

        },

        onDiscountsServiceUpdate: function (e, data) {
          var self = $scope.templatesCreatePricingMembers,
            discountCodes = DiscountsService.getModel() || [];

          self.discountCodes = discountCodes.sort(self._orderByBusinessRules);
        },

        onTemplatesServiceUpdate: function (e, data) {
          var self = $scope.templatesCreatePricingMembers;

          self.template = TemplatesService.getModel();
          self.processMemberships(self.template.entitlementConfiguration);
          self.memberRulesLoaded = true;
          self.loadingDiscounts = false;
        },

        onTemplatesCreatePricingUpdate: function (e, data) {
          var self = $scope.templatesCreatePricingMembers;

          self.template = TemplatesService.getModel();

          if (self.template.id) {
            // Next Tick
            $timeout(function () {
              if (self.memberRules && self.memberRules.length > 0) {
                self.onTemplatesCreateControllerSave();
              } else {
                self.getMembershipDiscounts();
              }
            }, 0);
          }
        },

        _reduceLevel: function(level) {
          return {
            displayName: level.displayName,
            name: level.name,
            id: level.id,
            membershipLevelGroup: level.membershipLevelGroup,
            membershipLevelCollection: level.membershipLevelCollection,
            auxiliary: level.auxiliary,
            displayOrder: level.displayOrder
          };
        },

        _orderByBusinessRules: function(a, b) {
          var displayNameA = a.displayName || a.name || '',
            displayNameB = b.displayName || b.name || '';

          return displayNameA.toUpperCase() > displayNameB.toUpperCase() ? 1 : -1;
        },

        processMembershipLevels: function (levels) {
          var self = $scope.templatesCreatePricingMembers,
              reducedLevels;
          levels.forEach(function (level) {
            level.displayName = self.getAuxBaseName(level);
          });
          reducedLevels = levels.map(self._reduceLevel);
          return reducedLevels.sort(self._orderByBusinessRules);
        },

        getAuxBaseName: function (level) {
          var displayName;
          if (level.auxiliary && level.membershipLevelCollection) {
            displayName = level.membershipLevelCollection[0].name + ' - ' + level.name;
          } else {
            displayName = level.name;
          }
          return displayName;
        }

      };

      $scope.templatesCreatePricingMembers.init();

    }
  ])
  .filter('ruleType', ['$filter', function ($filter) {

    return function (input, filterType) {

      var r = input;

      switch (filterType) {
      case 'both':
        r = input.filter(function (item) {
          return (item.discountCode && item.discountCode.code) && item.pricepoints.length > 0;
        });
        break;
      case 'discounts':
        r = input.filter(function (item) {
          return (item.discountCode && item.discountCode.code) && item.pricepoints.length === 0;
        });
        break;
      case 'limits':
        r = input.filter(function (item) {
          return item.pricepoints.length > 0 && !item.discountCode;
        });
        break;
      case 'norules':
        r = input.filter(function (item) {
          return !item.discountCode && item.pricepoints.length === 0;
        });
        break;
      }

      return r;

    };
  }]);
